import { Injectable } from '@angular/core';
import { filterNil } from '@datorama/akita';
import { ComponentController } from '@lycoris-nubila/ngx-lycoris';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';

import { NotificationApplicationPort } from 'application/notification/port/notification-application.port';
import { INotification } from 'domain/notification/notification';
import { AppService } from 'presentation/app.service';

import {
	MeetingRequestDialogState,
	MeetingRequestDialogStore,
} from './meeting-request-dialog.store';

@Injectable()
@UntilDestroy()
export class MeetingRequestDialogController extends ComponentController<MeetingRequestDialogState> {
	public locale$: Observable<string>;
	public notification$: Observable<INotification>;

	constructor(
		store: MeetingRequestDialogStore,
		private _appService: AppService,
		private _translateService: TranslateService,
		private _notificationApplicationPort: NotificationApplicationPort
	) {
		super(store);

		this._initObservables();
		this._initListeners();
	}

	public acceptMeeting(): Observable<string> {
		return this._notificationApplicationPort.acceptMeeting(
			this.getValue().notificationId
		);
	}

	public rejectMeeting(): Observable<void> {
		return this._notificationApplicationPort.rejectMeeting(
			this.getValue().notificationId
		);
	}

	public setNotificationId(notificationId: string): void {
		this.store.update({ notificationId });
	}

	private _initObservables() {
		this.notification$ = this.select('notificationId').pipe(
			filterNil,
			switchMap((notificationId) =>
				this._notificationApplicationPort.observeNotification(notificationId)
			),
			filterNil,
			shareReplay({ bufferSize: 1, refCount: true })
		);

		this.locale$ = this._appService.currentLang$;
	}

	private _initListeners() {
		this.select('notificationId')
			.pipe(
				filterNil,
				switchMap((notificationId) =>
					this._notificationApplicationPort.fetchNotification(notificationId)
				),
				untilDestroyed(this)
			)
			.subscribe();
	}
}
